import localforage from 'localforage'
import Api from '../core/Api'
import Geoloc from './Geoloc'
import Offline from './Offline'
import Bouteille from './Bouteille'
import Installation from "./Installation";

class Scan {
    static addOnlineScanBouteille(id) {
        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {
                    this
                        .getScanBouteille(id)
                        .then(data => {

                            delete data.id;

                            api
                                .post('/scans', data)
                                .then(res => {

                                    Offline
                                        .deleteAction(id, 'ScanBouteille')
                                        .then(() => {

                                            Scan.getList().then(list => {

                                                let newList = _.map(list, scan => {
                                                    if (scan.id === id) {
                                                        scan.id = res.data.id
                                                    }
                                                    return scan
                                                });

                                                localforage
                                                    .setItem('listScans', JSON.stringify(newList))
                                                    .then(() => resolve(true))
                                                    .catch(err => reject(err))

                                            })

                                        })
                                        .catch(err => reject(err))
                                })
                                .catch(err => {
                                    if (err.response && (err.response.status === 403 || err.response.status === 404)){
                                        Offline
                                            .deleteAction(id, 'ScanBouteille')
                                            .then( resolve(true) )
                                    } else {
                                        reject(err)
                                    }
                                })

                        })
                        .catch(err => {
                            api
                                .post('/mail/report', {text: err })
                                .then(() => resolve(true))
                                .catch(() => resolve(true))

                        })

                })
                .catch(err => reject(err))

        })

    }

    static addOnlineScanInstallation(id) {
        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {
                    this.getScanInstallation(id)
                        .then(data => {

                        delete data.id;

                        api.post('/scansInstallation', data)
                            .then(res => {

                                Offline
                                    .deleteAction(id, 'ScanInstallation')
                                    .then(() => {
                                        Scan.getList().then(list => {

                                            let newList = _.map(list, scan => {
                                                if (scan.id === id) {
                                                    scan.id = res.data.id
                                                }
                                                return scan
                                            });

                                            localforage
                                                .setItem('listScans', JSON.stringify(newList))
                                                .then(() => resolve(true))
                                                .catch(err => reject(err))

                                        })
                                    })
                                    .catch(err => reject(err))
                            })
                            .catch(err => {
                                if (err.response && (err.response.status === 403 || err.response.status === 404)){
                                    Offline
                                        .deleteAction(id, 'ScanInstallation')
                                        .then( resolve(true) )
                                } else {
                                    reject(err)
                                }
                            })
                    })
                    .catch(err => {
                        api
                            .post('/mail/report', {text: err })
                            .then(() => resolve(true))
                            .catch(() => resolve(true))
                    })
                })
                .catch(err => reject(err))

        })
    }

    static async addOfflineScanBouteille(idBouteille) {
        let bout = await Bouteille.getBouteille(idBouteille);

        if(bout.otag || (bout.key1 && bout.key2)){

            let pos = await Geoloc.getPosition();
            let crd = pos.coords;

            //console.log(crd);

            let data = {
                bouteille: idBouteille,
                lat: crd.latitude,
                lng: crd.longitude,
                date: moment().format("YYYY-MM-DD HH:mm:ss")
            };

            let newKey = 'N-' + +new Date();
            data.id = newKey;

            let list = await this.getList();
            list.push(data);

            await localforage.setItem('listScans', JSON.stringify(list));

            await Offline.saveAction({
                action: 'add',
                type: 'ScanBouteille',
                id: newKey
            })

        }

        return true

    }

    static async addOfflineScanInstallation(idInstallation) {
        let install = await Installation.getInstallation(idInstallation);

        if(install.i_tag !== ""){

            let pos = await Geoloc.getPosition();
            let crd = pos.coords;

            let data = {
                installation: idInstallation,
                lat: crd.latitude,
                lng: crd.longitude,
                date: moment().format("YYYY-MM-DD HH:mm:ss")
            };

            let newKey = 'N-' + +new Date();
            data.id = newKey;

            let list = await this.getList();
            list.push(data);

            await localforage.setItem('listScans', JSON.stringify(list));

            let lstOffline = await Offline.getList();

            _.remove(lstOffline, (item) => {
                return item.type === 'ScanInstallation' && item.idInstall === idInstallation;
            });

            await localforage.setItem('offlineActions', JSON.stringify(lstOffline));

            await Offline.saveAction({
                action: 'add',
                type: 'ScanInstallation',
                idInstall: idInstallation,
                id: newKey
            })

        }

        return true;
    }

    static getScansByBouteille(idBouteille) {

        return new Promise((resolve, reject) => {

            this.getList().then(list => {

                if (!_.includes(idBouteille, 'N-')) {
                    idBouteille = parseInt(idBouteille)
                }

                let scans = _.filter(list, ['bouteille', idBouteille]);

                if (scans) {
                    resolve(scans)
                } else {
                    reject('aucun scan')
                }
            })

        })

    }

    static getLastScanForBouteille(idBouteille) {

        return new Promise((resolve, reject) => {

            this
                .getScansByBouteille(idBouteille)
                .then(res => {
                    resolve(res[res.length - 1])
                })
                .catch(err => reject(err))

        })

    }

    static getScanInstallation(id) {
        return new Promise((resolve, reject) => {
          this.getList().then(list => {
              if (!_.includes(id, 'N-')) {
                  id = parseInt(id)
              }

              let scan = _.find(list, ['id', id]);

              if (scan) {
                  resolve(scan)
              } else {
                  reject('scan inexistant : '+ id)
              }
          })
        })
    }

    static getScanBouteille(id) {

        return new Promise((resolve, reject) => {

            this
                .getList().then(list => {

                if (!_.includes(id, 'N-')) {
                    id = parseInt(id)
                }

                let scan = _.find(list, ['id', id]);

                if (scan) {
                    resolve(scan)
                } else {
                    reject('scan inexistant : '+ id)
                }

            })

        })

    }

    static getList() {
        return new Promise((resolve, reject) => {
            localforage
                .getItem('listScans')
                .then(res => { const parsed = JSON.parse(res); resolve(Array.isArray(parsed) ? parsed : []) })
                .catch(err => reject(err))
        })

    }

}

export default Scan



// WEBPACK FOOTER //
// ./src/js/models/Scan.js